import {
  Box, Button, Container, Flex, Heading, Text,
} from '@chakra-ui/react';
import { FiArrowDown, FiArrowRight, FiArrowUpRight } from 'react-icons/fi';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql } from 'gatsby';
import React, { useRef } from 'react';
import axios from 'axios';
import { generate } from 'shortid';
import {
  CalloutPhoneNumber,
  CheckMath,
  HeroHome,
  HorizontalText,
  HowItWorks,
  ReasonForSelling,
  ReviewCallout,
  ReviewsRotator,
  StressFreeSection,
  UpfrontOfferBlock,
  UsVsAgent,
  WeTheBestSection,
  WhyusSection,
  SEO,
  MainFrictionReducerSection,
  HalfByHalfSection,
} from '../components/_index';
import FlareGroup6 from '../assets/shapes/shape-group-6.svg';
import GoogleLogo from '../assets/Google_2015_logo.svg';

const seoContent = {
  title: "We Buy Houses in Bay Area - [We're #1 For A Reason]",
  description:
    'We Buy Houses in . We are a local home buying company in and we pay cash for houses. "Sell my house without cleaning or repairing or paying closing costs!"',
};

export const IndexPage = ({ data, location }) => {
  return (
    <div>
      <SEO
        location={location}
        title={seoContent.title}
        description={seoContent.description}
      />
      <Box
        minH="700px"
        pt={10}
      >
        <Container
          maxW="container.xl"
          py={10}
        >
          <HeroHome
            data={data}
            bgR="brand.five"
            pt={20}
          />
        </Container>
        <main>
          <Box backgroundColor="brand.five">
            <Box marginTop={{ base: '0px', md: '-200px' }}>
              <ReviewCallout />
            </Box>
          </Box>
          <Box
            backgroundColor="gray.100"
            py={4}
          >
            <Container
              maxW="container.xl"
              // display={{ base: 'none', md: 'block' }}
            >
              <Heading
                variant="sec"
                as="h4"
                size="3xl"
              >
                Join the
                {' '}
                <span className="highlight">hundreds</span>
                {' '}
                of
                {' '}
                <span className="highlight">happy homeowners</span>
                {' '}
                that sold
                with us!
              </Heading>
            </Container>

            <ReviewsRotator />
          </Box>
          <CheckMath />
          <HowItWorks />
          {/* <Box backgroundColor="brand.five" py={10}>
            <Container
              maxWidth="container.xl"
              display={{ base: 'block', md: 'block' }}
            >
              <MainFrictionReducerSection />
            </Container>
          </Box> */}

          <Box />
          <WhyusSection img={data.whyUsImg} />
          <Box
            backgroundColor="gray.200"
            py={10}
          >
            {/* <Container maxWidth="container.xl">
              <Reviews />
            </Container> */}
            <Container
              maxWidth="container.xl"
              display={{ base: 'none', md: 'block' }}
            >
              <Heading
                as="h3"
                size="2xl"
              >
                We help hundreds of families every year move on to the
                {' '}
                <span className="highlight">next step in their lives</span>
                {' '}
                by
                buying their homes at a
                {' '}
                <span className="highlight">fair and honest price</span>
                {' '}
                no
                matter the condition.
              </Heading>
            </Container>
            <Container
              maxWidth="container.xl"
              display={{ base: 'block', md: 'none' }}
            >
              <Heading
                as="h3"
                size="xl"
              >
                We help hundreds of families every year move on to the
                {' '}
                <span className="highlight">next step in their lives</span>
                {' '}
                by
                buying their homes at a
                {' '}
                <span className="highlight">fair and honest price</span>
                {' '}
                no
                matter the condition.
              </Heading>
            </Container>
          </Box>
          <StressFreeSection
            img={data.stressFreeImg}
            flareImg=""
          />

          <HorizontalText />
          <WeTheBestSection
            img={data.super}
            flareImg={data.flareImg}
          />
          <ReasonForSelling />
          {/* <CleanBlock /> */}
          <UsVsAgent />

          <UpfrontOfferBlock />
          <CalloutPhoneNumber />
        </main>
      </Box>
    </div>
  );
};

export const query = graphql`
  query {
    eugeneProfileImg: file(relativePath: { eq: "team/eugene-profile.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    background: file(relativePath: { eq: "background.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    super: file(relativePath: { eq: "illustrations/launch-2.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    whyUsImg: file(relativePath: { eq: "agent-house-group.png" }) {
      childImageSharp {
        gatsbyImageData(width: 500, placeholder: BLURRED)
      }
    }
    flareImg: file(relativePath: { eq: "illustrations/flare-3.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    ellipseSix: file(relativePath: { eq: "illustrations/ellipse-6.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
    stressFreeImg: file(relativePath: { eq: "ill-group-2.png" }) {
      childImageSharp {
        gatsbyImageData(width: 800, placeholder: BLURRED)
      }
    }
  }
`;

export default IndexPage;
